import * as ng from 'angular';
import * as uib from 'angular-ui-bootstrap';
import { EditorModel } from '../editor';
import { WebRegEditorModel } from './web-reg/web-reg-editor.model';

const manageDomainViewUrl = require('./manage-domain.html');

ng.module('e360')
   .factory('showManageDomainModal', showManageDomainModalFactory);

showManageDomainModalFactory.$inject = ['$uibModal', 'session']
function showManageDomainModalFactory($uibModal:uib.IModalService, session) {
   return showManageDomainModal;

   function showManageDomainModal(stage:string, model:EditorModel, nameservers:string[]) {
      let modal = $uibModal.open({
         size: 'md',
         backdrop: 'static',
         templateUrl: manageDomainViewUrl,
         controller: 'ManageDomainController',
         controllerAs: 'ctrl',
         keyboard: false,
         resolve: {
            stage: () => stage,
            model: () => model,
            nameservers: () => nameservers
         }
      });

      return modal.result;
   }
}

export class ManageDomainController {
   isActivating = false;

   type:string;
   domain:string;
   subdomain:string;

   // String used in label after subdomain input
   rootDomain:string;

   static $inject = [
      '$uibModalInstance',
      'experiencesService',
      'toast',
      'session',
      'stage',
      'model',
      'nameservers'
   ];

   constructor (
      private $uibModalInstance,
      private experiencesService,
      private toast,
      private session,
      public stage:string,
      public model:EditorModel,
      public nameservers:string[]
   ) {
      this.domain = model.settings.domain;
      this.subdomain = model.settings.subdomain;
      this.type = this.domain ? 'domain' : 'subdomain';

      if (model instanceof WebRegEditorModel) {
         this.rootDomain = this.session.selfRegRootDomain();
      } else {
         this.rootDomain = this.session.rsvpRootDomain();
      }
   }

   get isNew() {
      return this.model.isNew;
   }

   get hadCustomDomain() {
      return this.model.settings.domain;
   }

   get canActivate() {
      return this.stage === 'config' && this.type === 'domain' && this.domain && this.domain !== this.model.settings.domain;
   }

   get canViewNameservers() {
      return this.stage === 'config' && this.type === 'domain' && this.domain && this.domain === this.model.settings.domain;
   }

   get canSave() {
      return this.stage === 'config' && this.type == 'subdomain' && this.subdomain !== this.model.settings.subdomain;
   }

   activate() {
      let domainRegex = /^(([a-z]{1})|([a-z]{1}[a-z]{1})|([a-z]{1}[0-9]{1})|([0-9]{1}[a-z]{1})|([a-z0-9][a-z0-9-_]{1,61}[a-z0-9]))\.([a-z]{2,6}|[a-z0-9-]{2,30}\.[a-z]{2,3})$/;
      if (!domainRegex.test(this.domain)
         || this.domain.substr(0, 5) == 'http:'
         || this.domain.substr(0, 6) == 'https:'
         || this.domain.substr(0, 4) == 'www.'
      ) {
         this.toast.error()
            .message('Please enter a valid lowercase top level domain, not starting with http:// or https:// or www.')
            .send();
         return;
      }

      this.isActivating = true;
      this.experiencesService.cloudFlareActivate(this.model.experience.id, this.domain).then(res => {
         this.model.settings.domain = this.domain;
         this.model.settings.subdomain = null;

         this.isActivating = false;
         this.nameservers = res.result.name_servers;

         this.stage = 'nameservers';
      }).finally(() => this.isActivating = false);
   }

   cancel() {
      this.$uibModalInstance.dismiss('cancel');
   }

   save() {
      let result = {
         domain: null,
         subdomain: null
      };

      if (this.type == 'subdomain') {
         result.subdomain = this.subdomain;
      } else {
         result.domain = this.domain;
      }

      this.$uibModalInstance.close(result);
   }
}

ng.module('e360')
   .controller('ManageDomainController', ManageDomainController);
